import { Context, Layer, Redacted } from "effect";

export type GitHubAppConfigShape = {
  readonly appId: string;
  readonly privateKey: Redacted.Redacted;
};

export class GitHubAppConfig extends Context.Service<
  GitHubAppConfig,
  GitHubAppConfigShape
>()("@vivus/GitHubAppConfig") {}

export type GitHubAppConfigEnv = {
  GH_APP_ID: string;
  GH_APP_PRIVATE_KEY_BASE64: string;
};

export const makeGitHubAppConfigLayer = (
  env: GitHubAppConfigEnv
) =>
  Layer.succeed(GitHubAppConfig, {
    appId: env.GH_APP_ID,
    privateKey: Redacted.make(
      Buffer.from(
        env.GH_APP_PRIVATE_KEY_BASE64,
        "base64"
      ).toString("utf-8")
    ),
  });
